export const campaignTypesEnum = {
  ABTesting: "A/B Test",
  Regular: "Regular",
} as { [key: string]: string };

export const campaignStatusEnum = {
  Draft: "Draft",
  Submitted: "Submitted",
  Completed: "Completed",
  Failed: "Failed",
  ABTestWaiting: "A/B Test Waiting",
  InProgress: "In Progress",
} as { [key: string]: string };
